import styled from "styled-components";

import { ANIMATION_FUNCTION } from "@similarweb/ui-components";

const CHILDREN_MAX_HEIGHT = "500px";
export const EXPAND_TRANSITION_DURATION = "300ms";

export const ExpandableMenuItemWrapper = styled.div`
    width: 100%;
`;

export const ChildrenContainer = styled.div<{ $isExpanded: boolean }>`
    max-height: ${({ $isExpanded }) => ($isExpanded ? CHILDREN_MAX_HEIGHT : "0")};
    overflow: hidden;
    transition: max-height ${EXPAND_TRANSITION_DURATION} ${ANIMATION_FUNCTION};
`;

export const IconPlaceholder = styled.div`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
`;

export const ExpandChevronWrapper = styled.div<{ $isExpanded: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(${({ $isExpanded }) => ($isExpanded ? "180deg" : "0deg")});
    transition: transform ${EXPAND_TRANSITION_DURATION} ${ANIMATION_FUNCTION};
`;
